<template>
	<v-container fill-height grid-list-xl class="pt-0">
  	<v-layout  align-star  row fill-height>
			<v-flex xs12 v-if="getCarrito.length ===  0" >
				<v-alert type="info">
		      Tu carrito esta vacio.
		    </v-alert>
			</v-flex>
  		<v-flex xs12 v-else>
  			<v-card class="elevation-0">
  				<v-layout row wrap>
  					<v-flex xs12>
						  <v-layout justify-end row wrap>
						    <v-flex xs12>
						    	<v-card outlined>
						    		<v-layout row wrap>
						    		  <v-flex xs5 class="pr-0">
						    		  	<v-card class="transparent elevation-0">
						    		  	  <v-card-text class="pr-0 pl-1">
								    		    <div class="text-xs-left "><h3><strong>Divisa:</strong></h3></div>
								    		    <v-divider></v-divider>
								    		    <div class="text-xs-left blue--text font-weight-black">Importe:</div>
								    		    <div class="text-xs-left blue--text font-weight-black">Descuento:</div>
	
								    		    <!-- <div class="text-xs-left "><h3>Subtotal:</h3></div> -->
								    		    <!-- <div class="text-xs-left font-weight-black "><h3>Iva:</h3></div> -->
								    		    <div class="text-xs-left font-weight-black"><h3>Total:</h3></div>
						    		  	  </v-card-text>
						    		  	</v-card>
						    		  </v-flex>

						    		  <v-flex xs7>
						    		    <v-card class="transparent elevation-0">
						    		  	  <v-card-text align="right" class="pr-1 pl-1">
								    		    <div class="text-xs-left "><h3>MXN</h3></div>

								    		    <v-divider></v-divider>
								    		    <div class="text-xs-left blue--text font-weight-black"><h3>{{ importedoc }}</h3></div>

								    		    <div class="text-xs-left blue--text font-weight-black"><h3>{{ descuentodoc }}</h3></div>
								    		    
								    		    <!-- <div class="text-xs-left "><h3><strong>{{ subtotal }}</strong></h3></div> -->
								    		    <!-- <div class="text-xs-left "><h3><strong>{{ iva }}</strong></h3></div> -->
								    		    <div class="text-xs-left "><h3><strong>{{ total }}</strong></h3></div>
						    		  	  </v-card-text>
						    		  	</v-card>
						    		  </v-flex>
						    		</v-layout>
						  		</v-card>
						    </v-flex>
						  </v-layout>
				  	</v-flex>

  				  <v-flex xs12 class="pt-0">
  				    <v-btn block color="red darken-2" dark :to="{name:'carrito'}">Proceder al Pago<v-icon right>shopping_cart</v-icon></v-btn>
  				  </v-flex>

  				  <v-flex xs12 class="pt-0">
					    <v-btn block color="blue darken-4" dark  @click="ocultar">Seguir compranod<v-icon right>reply</v-icon></v-btn>
  				  </v-flex>

  				</v-layout>

  				<v-divider></v-divider>
  			</v-card>
				<v-card class="elevation-0" v-for="(art , i) in getCarrito" :key="i">

					<v-container fill-height grid-list-xl class="pt-0 pa-0">
						<v-layout row wrap>
						  <v-flex xs3 class="mr-0 pr-0">
			          <v-card-text align="center" class="mb-0 pb-0 pa-0 pt-3">
			            <v-img :src="url + art.foto" contain v-if="art.foto"/>
			            <v-img src="@/assets/blanco.jpg" contain v-else/>
			          </v-card-text>
						  </v-flex>

						  <v-flex xs3 class="mr-0 pr-0 px-0">
			          <v-card-text align="left" class="mb-0 pb-0 px-0">
			            <h5>{{art.nomart}}</h5>
			          </v-card-text>
						  </v-flex>

						  <v-flex xs6   text-right class="mr-0 pl-0">
			          <v-card-actions >
			            
			            <v-btn small  icon  color="success" @click="add(art)"><v-icon >add</v-icon></v-btn>
			            <v-spacer></v-spacer>
			            <h5>{{ art.cantidad }}</h5>

			            <v-spacer></v-spacer>
			            <v-btn small  icon  dark color="orange " @click="remove(art)"><v-icon >remove</v-icon></v-btn>
			          </v-card-actions>

			          <v-card-text class="pt-1 pa-0">
			          	<h5 class="text-xs-center blue--text font-weight-black">Precio: {{ art.precio1 }} </h5>
			          	<h5>Importe: {{ art.total}}</h5>
			          </v-card-text>
						  </v-flex>
						</v-layout>
					</v-container>
				<v-divider></v-divider>
        </v-card>
			</v-flex>
	  </v-layout>		
	</v-container>
</template>

<script>
  import tempCarrito from '@/mixins/tempCarrito.js';
	import {mapActions, mapGetters, mapState} from 'vuex'
	var accounting = require("accounting");

	export default{
		mixins:[tempCarrito],
		data(){
			return{
				importedoc:0.00,
				descuentodoc:0.00,
				total: 0,
				iva:0,
				subtotal:0,
				url:''
			}
		},

		created(){
			this.url = this.$http.options.root + 'fotos/'
		},

		computed: {
			...mapGetters('carrito',['getCarrito']),
			...mapState('carrito',['carrito']),

    },

    watch:{

    	getCarrito: function(){
	    	this.recalcular()
	    }
    },

    methods: {
    	ocultar(){
    		this.$store.state.carrito.carritovisible = false
    	},

    	recalcular(){

		    this.formarCarrito()
    	},


    	add(articulo){
    		for (var i = this.getCarrito.length - 1; i >= 0; i--) {
    			if(this.getCarrito[i].codigo == articulo.codigo){
    				this.getCarrito[i].cantidad = this.getCarrito[i].cantidad + 1
    			}
    		}

  			this.recalcular()
    	},

    	remove(articulo){
    		for (var i = this.getCarrito.length - 1; i >= 0; i--) {
    			if(this.getCarrito[i].codigo == articulo.codigo){
    				this.getCarrito[i].cantidad = this.getCarrito[i].cantidad - 1
    				if(this.getCarrito[i].cantidad == 0 ){
    					this.getCarrito.splice(i, 1)
    				}
    			}
    		}

  			this.recalcular()
    	},
    }
	}
</script>
